"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationRulesHistoryEventSchema = exports.ImplementationRulesExtractionAttemptHistoryEventSchema = exports.ImplementationRulesHistoryResultSchema = exports.ImplementationRulesHistoryGeneratorSchema = exports.ImplementationRulesHistorySourceSchema = exports.RulesVerdict = void 0;
exports.computeRulesVerdict = computeRulesVerdict;
const z = require("zod");
const implementation_rules_1 = require("./implementation-rules");
var RulesVerdict;
(function (RulesVerdict) {
    RulesVerdict["Pass"] = "pass";
    RulesVerdict["ConditionalPass"] = "conditional-pass";
    RulesVerdict["NeedsRevision"] = "needs-revision";
    RulesVerdict["NeedsRework"] = "needs-rework";
})(RulesVerdict || (exports.RulesVerdict = RulesVerdict = {}));
function computeRulesVerdict(counts) {
    if (counts.pinErrors > 0 ||
        counts.polarityErrors > 0 ||
        counts.materialInventedRules > 0 ||
        counts.factualErrors > 0) {
        return RulesVerdict.NeedsRework;
    }
    if (counts.gaps > 0) {
        return RulesVerdict.NeedsRevision;
    }
    if (counts.scopeViolations > 0 || counts.formatIssues > 0) {
        return RulesVerdict.ConditionalPass;
    }
    return RulesVerdict.Pass;
}
exports.ImplementationRulesHistorySourceSchema = z
    .object({
    fileId: z.string().nullable(),
    fingerprint: z.string().nullable(),
})
    .strict();
exports.ImplementationRulesHistoryGeneratorSchema = z
    .object({
    extractorVersion: z.number().int().nonnegative(),
    variantId: z.string(),
    configHash: z.string(),
    promptVariant: z.string(),
    modelCard: z.string(),
    effort: z.string(),
    workflowRunId: z.string(),
})
    .strict();
const HistoryResultBaseSchema = z.object({
    counts: implementation_rules_1.RulesRunCountsSchema,
    verdict: z.nativeEnum(RulesVerdict),
    coverage: implementation_rules_1.RulesRunCoverageSchema,
    contentHash: z.string(),
    createdAt: z.string().datetime(),
});
exports.ImplementationRulesHistoryResultSchema = z.discriminatedUnion('disposition', [
    HistoryResultBaseSchema.extend({
        disposition: z.literal('committed'),
        retainedFromResolutionEntryId: z.never().optional(),
    }).strict(),
    HistoryResultBaseSchema.extend({
        disposition: z.literal('retained'),
        retainedFromResolutionEntryId: z.string(),
    }).strict(),
    HistoryResultBaseSchema.extend({
        disposition: z.literal('recorded'),
        retainedFromResolutionEntryId: z.never().optional(),
    }).strict(),
]);
exports.ImplementationRulesExtractionAttemptHistoryEventSchema = z
    .object({
    kind: z.literal('extraction-attempt'),
    attempt: implementation_rules_1.ImplementationRulesAttemptSchema,
    source: exports.ImplementationRulesHistorySourceSchema,
    generator: exports.ImplementationRulesHistoryGeneratorSchema,
    result: exports.ImplementationRulesHistoryResultSchema,
})
    .strict();
exports.ImplementationRulesHistoryEventSchema = z.discriminatedUnion('kind', [
    exports.ImplementationRulesExtractionAttemptHistoryEventSchema,
    z
        .object({
        kind: z.literal('operator-edit'),
        baseContentHash: z.string(),
        resultContentHash: z.string(),
        createdRuleIds: z.string().array(),
        rulesOnlyEntryId: z.string().optional(),
    })
        .strict(),
]);
//# sourceMappingURL=implementation-rules-history-event.js.map